<template>
	<div
		v-if="show"
		class="modal-wrapper"
		:class="{
			'modal-wrapper__show': showModalContent,
		}"
	>
		<div
			class="modal-overlay"
			@click="persistent ? false : emit('on-close')"
		/>
		<BaseCard
			:style="{
				'max-width': typeCheck(maxWidth),
				'max-height':
					maxHeight == undefined ? '' : typeCheck(maxHeight),
				padding: showLogoTitle ? '30px' : '',
			}"
			color="background-primary"
			class="modal"
		>
			<div
				class="modal__header"
				:class="{
					'align-start mb-4 gap-3': Boolean($slots?.['title']),
				}"
				:style="showLogoTitle ? 'margin-bottom: 14px;' : ''"
				v-if="!titleHidden"
			>
				<slot v-if="$slots?.['title']" name="title"></slot>
				<a
					href="https://doc.doriclub.uz/"
					target="_blank"
					class="d-flex align-center"
					v-else-if="showLogoTitle"
				>
					<img
						loading="lazy"
						class="app-logo__image"
						style="
							width: 162.99px;
							height: 162.99px;
							max-height: 17px;
							max-width: 162.99px;
						"
						src="@/shared/assets/svg/logo.svg"
						alt="Doriclub"
					/>
				</a>
				<h4 class="headers-4 | text-gray900 modal__title" v-else>
					{{ title }}
				</h4>
				<img
					loading="lazy"
					src="@/shared/assets/svg/icon-close.svg"
					alt="close icon"
					v-if="!hideCloseIcon"
					class="cursor-pointer"
					@click="emit('on-close')"
				/>
				<slot name="hideCloseIcon" v-else></slot>
			</div>
			<div
				class="modal__body"
				:class="bodyOverflowVisible ? 'overflow-visible' : ''"
			>
				<slot />
			</div>
			<div class="modal__footer">
				<slot name="footer" />
			</div>
		</BaseCard>
	</div>
</template>

<script setup>
import { onBeforeUnmount, watch, ref, defineProps, defineEmits, defineOptions } from "vue";

defineOptions({
	name: 'BaseModal',
})

const props = defineProps({
	showModal: {
		type: Boolean,
		required: true,
	},
	bodyOverflowVisible: {
		type: Boolean,
		default: false,
	},
	titleHidden: {
		type: Boolean,
		default: false,
	},
	persistent: {
		type: Boolean,
		default: false,
	},
	showLogoTitle: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		default: "",
	},
	maxWidth: {
		type: [Number, String],
	},
	minWidth: {
		type: [Number, String],
	},
	maxHeight: {
		type: [Number, String],
		default: undefined,
	},
	minHeight: {
		type: [Number, String],
	},
	hideCloseIcon: {
		type: Boolean,
		default: false,
	},
});

const show = ref(false);
const showModalContent = ref(false);

const emit = defineEmits(["on-close"]);

watch(
	() => props.showModal,
	(newValue) => {
		if (newValue) {
			show.value = true;
			setTimeout(() => {
				showModalContent.value = true;
			}, 10);
			// document.documentElement.style.overflow = "hidden";
			document.documentElement.style.overflow = props.showModalContent ? "hidden" : "";
		} else {
			showModalContent.value = false;
			setTimeout(() => {
				show.value = false;
				document.documentElement.style.overflow = props.showModalContent ? "hidden" : "";
			}, 200);
		}
	},
	{ immediate: true }
);

onBeforeUnmount(() => {
	setTimeout(() => {
		show.value = false;
		// document.documentElement.style.overflow = false ? 'hidden' : '';
		document.documentElement.style.overflow = "";
	}, 200);
});

const typeCheck = (value) =>
	typeof value === "string" ? value : `${value ?? 600}px`;
</script>

<style lang="scss">
html:has(.modal-wrapper__show) {
	overflow: hidden;
}
</style>

<style lang="scss" scoped>
.modal {
	width: 100%;
	max-height: calc(100% - 32px);
	min-height: 0;
	overflow: auto;
	z-index: 1002;
	margin: 0 16px;
	transform: translateY(-10%);
	transition: transform 0.2s;

	&-wrapper__show .modal {
		transform: translateY(0px);
	}

	&::-webkit-scrollbar {
		width: 0;
		height: 2px;
	}

	&-wrapper {
		position: fixed;
		display: flex;
		align-items: center;
		justify-content: center;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		opacity: 0;
		z-index: 1000;
		pointer-events: none;
		overflow: hidden;
		transition: all 0.2s;

		&__show {
			opacity: 1;
			pointer-events: all;
		}
	}
	&-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100vw;
		height: 100vh;
		background: #00000080;
		z-index: 1001;
	}
	&__header {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		margin: 0 0 24px;
	}
	&__title {
		word-break: break-word;
	}
	&__body {
		overflow: auto;
		overflow-y: hidden;
		max-height: calc(100% - 105px);
	}
}
</style>
